<template>
    <v-popover :disabled="!deletable" trigger="hover" placement="top">
        <router-link :to="{ name: 'view-profile', params: { user: user.id } }" :name="this._uid + '-tippy'" ref="btn" class="avatar tooltip-target" v-if="user">
            <img :src="user.avatar" :width="size" :height="size" class="circle border border-white" v-if="user && user.avatar">
            <span class="initials circle border border-white" v-if="user && !user.avatar">{{ user.initials }}</span>
        </router-link>

        <!-- This will be the content of the popover -->
        <template slot="popover">
            <a href='#' class='remove' @click.prevent='remove(user.id)'>Remove</a>
        </template>
    </v-popover>
</template>

<script>

    export default {
        props: {
            user: {
                default: null,
            },
            deletable: {
                default: false,
            },
            size: {
                default: 32,
            }
        },
        data () {
            return {
                activeTippy: null,
            }
        },
        mounted() {
        },
        methods:{
            remove(userID){
                this.$emit('remove-user', userID);
            },
            showTippy(el){
                this.activeTippy = el;
            }
        }
    }
</script>

<style lang="scss">
    a.remove{
        color: #fff;
        font-size: 12px;
        line-height: 12px;
    }
</style>